import { greenShade, slightOrange, slightRed } from "../../../config/ColorObj";

export const getInitials = (name) =>
    name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);

export const formatINR = (n) => "₹" + n.toLocaleString("en-IN");

export const getPerfMeta = (pct) => {
    if (pct >= 70) return { label: "High", colorClass: "hi" };
    if (pct >= 40) return { label: "Medium", colorClass: "mid" };
    return { label: "Low", colorClass: "lo" };
};

export const PERF_COLORS = { hi: greenShade, mid: slightOrange, lo: slightRed };
